import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../auth.service";
import {HttpClient} from "@angular/common/http";
import {JsonPipe} from "@angular/common";

@Component({
  selector: 'app-user-info',
  standalone: true,
  imports: [
    JsonPipe
  ],
  templateUrl: './user-info.component.html',
  styleUrl: './user-info.component.css'
})
export class UserInfoComponent implements OnInit{
  
  user:any;
  
  constructor(private authService: AuthService, private http:HttpClient) {
  
  }
  
  ngOnInit(): void {
    
    /*
    this.http.get('io/me').subscribe((r) => {
      this.user = r;
      console.log(r);
    });
    
     */
    
    this.http.get('io/user').subscribe((r) => {
      this.user = r;
    });
    
  }
  
}
